/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react";
import { type CommonBuilderProps, type QuestionFormComponents } from "features/Library/Common/props";
import QuestionWithAnswers from "features/Library/Common/QuestionsForm/Questions/QuestionsBuilder/QuestionWithAnswers/QuestionWithAnswers";
import { MAX_QUESTIONS_LENGTH } from "features/Library/Common/constants";
import { type IQuestionBase } from "features/Library/Common/models";
import { AddButton } from "components/buttons/iconButtons/AddButton/AddButton";

export interface QuestionsBuilderProps extends CommonBuilderProps, QuestionFormComponents<IQuestionBase> {
  questions: IQuestionBase[];
  defaultDataProvider: () => IQuestionBase;
}

export const QuestionsBuilder = (props: QuestionsBuilderProps) => {
  const {
    questions,
    validatedFieldProps,
    arrayHelpers,
    onBlur,
    onChanged,
    disabled,
    defaultDataProvider,
    propertyNamePrefix,
  } = props;
  const { QuestionRenderer, AnswersBuilder, QuestionHeader } = props;

  const onAddQuestion = () => {
    arrayHelpers.push(defaultDataProvider());
    setTimeout(() => {
      onChanged?.();
    }, 0);
  };

  const onRemoveQuestion = useCallback((index: number) => {
    arrayHelpers.remove(index);
    setTimeout(() => {
      onChanged?.();
    }, 0);
  }, []);

  const onReplaceQuestion = useCallback(
    (index: number) => (question: IQuestionBase) => {
      arrayHelpers.replace(index, question);
      setTimeout(() => {
        onChanged?.();
      }, 0);
    },
    [],
  );

  const onHandleBlur = useCallback((propsName: string) => onBlur(propsName), []);

  return (
    <>
      {questions.map((question: IQuestionBase, index: number) => (
        <QuestionWithAnswers
          question={question}
          index={index}
          onRemove={onRemoveQuestion}
          onBlur={onHandleBlur}
          onChanged={onChanged}
          arrayHelpers={arrayHelpers}
          validatedFieldProps={validatedFieldProps}
          key={question.id ?? index}
          QuestionRenderer={QuestionRenderer}
          AnswersBuilder={AnswersBuilder}
          QuestionHeader={QuestionHeader}
          onReplaceQuestion={onReplaceQuestion}
          disabled={disabled}
          propertyNamePrefix={`${propertyNamePrefix}questions.${index}.`}
        />
      ))}

      {!disabled && questions.length < MAX_QUESTIONS_LENGTH && (
        <AddButton label={"Add question"} onClick={onAddQuestion} />
      )}
    </>
  );
};

export default QuestionsBuilder;
